// extracted by mini-css-extract-plugin
module.exports = {"form":"nps_modal-module_form_35a11"};